import { createAction, props } from '@ngrx/store';
import { ContractError } from 'src/app/core/models/models';
import { AncillariesValidation } from 'src/app/core/models/special-requests.model';
import { IOffices } from 'src/app/core/models/IGdsCredentials.model';
import { IRequestAdditionalFlightInfo } from 'src/app/core/models/request-info-flight.model';
import {
  PnrInfo,
  PnrAvailableOption,
  PassengerQuote,
  QuoteRequest,
  ISRequestValidationQuote,
  ISRequestValidation,
  IAdditionalFlightInfo
} from 'src/app/core/models/itinerary.model';
import {
  CancellationQuote,
  PenaltyFareBasisMachineLearning
} from 'src/app/core/models/cancellation.model';
import {
  IVoidTransactionQuote,
  IVoidTransactionResponse
} from 'src/app/core/models/void-transaction.model';

export const LoadPnr = createAction('[Search Result Page] Load pnr from route');

export const LoadPnrSuccess = createAction(
  '[Search Result Page] Load pnr info success',
  props<{ pnrInfo: PnrInfo }>()
);

export const ClearPnrInfo = createAction('[Clear Search Result Page] Clear all PnrInfo');

export const LoadPnrFail = createAction(
  '[Search Result Page] Load pnr fail',
  props<{ error: ContractError }>()
);

export const SetSelectedPassengersHasInvalidCoupons = createAction(
  '[Search Result Page] Set SetSelectedPassengersHasInvalidCoupons status info',
  props<{ selectedPassengersHasInvalidCoupons: boolean }>()
);

export const ClearPnrSuccess = createAction(
  '[Clear Search Result Page] Clear preview load pnr success'
);

export const LoadSelectedPassengers = createAction(
  '[Itinerary/Info Page] User select a passenger',
  props<{ selectedPassengersQuote: PassengerQuote[] }>()
);

export const LoadSelectedSegments = createAction(
  '[Itinerary/Info Page] User select a segment',
  props<{ selectedSegments: number[] }>()
);

export const LoadAvailableOption = createAction(
  '[Itinerary/Info Page] Load available actions',
  props<{ quoteRequest: QuoteRequest }>()
);

export const GoToInvoluntaryChange = createAction(
  '[Itinerary/Info Page] Go To Involuntary Change',
  props<{ quoteRequest: QuoteRequest }>()
);

export const LoadAvailableOptionSuccess = createAction(
  '[Itinerary/Info Page] Success Loading available actions',
  props<{ pnrAvailableOption: PnrAvailableOption; machineLearningEnabled: boolean }>()
);

export const SRequestValidationPerFlight = createAction(
  '[Itinerary/Info Page] Load SRequest compatibility per flight',
  props<{ quoteRequest: ISRequestValidationQuote }>()
);

export const SRequestValidationPerFlightSuccess = createAction(
  '[Itinerary/Info Page] Load SRequest compatibility per flight Success',
  props<{ response: ISRequestValidation[] }>()
);

export const SRequestValidationPerFlightFailed = createAction(
  '[Itinerary/Info Page] Load SRequest compatibility per flight Failed',
  props<{ error: ContractError }>()
);

export const ResetSRequestValidationPerFlight = createAction(
  '[Itinerary/Info Page] Reset SRequest compatibility per flight state'
);

export const CloseModal = createAction('[Search Result Page] Close Modal Error');

export const CloseModalAction = createAction('[Search Result Page] Close Modal Action Message');

export const ChooseActionMode = createAction(
  '[Search Result Page] Change Action Mode',
  props<{ actionActive: string }>()
);

export const ChangeToPnrSplitted = createAction(
  '[Search Result Page] Splitted Pnr',
  props<{ cancellationQuote: CancellationQuote }>()
);

export const SplitPnrRequest = createAction(
  '[Pnr] Split pnr request',
  props<{ quoteRequest: QuoteRequest }>()
);

export const SplitPnrSuccess = createAction(
  '[Pnr] Split pnr request success',
  props<{ pnr: PnrInfo }>()
);

export const SplitPnrFail = createAction(
  '[Pnr] Split pnr request fail',
  props<{ splitError: ContractError }>()
);

export const UpdateOverrideSegments = createAction(
  '[Pnr] Update Override Segments',
  props<{ overrideSegments: number[] }>()
);

export const setCommision = createAction('[Pnr] Set Commission value', props<{ value: number }>());

export const UpdatePnrInfo = createAction('[Pnr] Update Pnr Info', props<{ pnrInfo: PnrInfo }>());

export const UpdateAncillariesValidation = createAction(
  '[Pnr] Update Ancillaries Validation',
  props<{ ancillaries: AncillariesValidation[] }>()
);

export const ForceRefreshSesionAndVoid = createAction(
  '[Pnr] Force refresh token in sesion before void transaction',
  props<{ quoteRequest: IVoidTransactionQuote }>()
);

export const VoidTransaction = createAction(
  '[Pnr] Apply void transaction',
  props<{ quoteRequest: IVoidTransactionQuote }>()
);

export const VoidTransactionSuccess = createAction(
  '[Pnr] Apply void transaction success',
  props<{ response: IVoidTransactionResponse[] }>()
);

export const VoidTransactionFail = createAction(
  '[Pnr] Apply void transaction fail',
  props<{ error: ContractError; message: string }>()
);

export const LoadPenaltyTextAI = createAction(
  '[Pnr] Load penalty text AI',
  props<{ quoteRequest: QuoteRequest }>()
);

export const LoadPenaltyTextAISuccess = createAction(
  '[Pnr] Load penalty text AI success',
  props<{ penalty: PenaltyFareBasisMachineLearning }>()
);

export const LoadRulesIA = createAction(
  '[Pnr] Load rules AI',
  props<{ quoteRequest: QuoteRequest }>()
);

export const LoadRulesIASuccess = createAction(
  '[Pnr] Load rules AI success',
  props<{ penalty: PenaltyFareBasisMachineLearning }>()
);

export const LoadRulesIAFail = createAction(
  '[Pnr] Load rules AI fail',
  props<{ error: ContractError }>()
);

export const LoadOfficeCountry = createAction(
  '[Pnr] Load Office Country',
  props<{ officeCountry: IOffices }>()
);

export const SetReceivedFrom = createAction(
  '[Pnr] Set Received From',
  props<{ receivedFrom: string }>()
);

export const RemoveReceivedFrom = createAction('[Pnr] Remove Received From');

export const UpdatePassengersQuote = createAction(
  '[Pnr] Update Passengers Quote',
  props<{ selectedPassengersQuote: PassengerQuote[] }>()
);

export const GetAdditionalFlightInfo = createAction(
  '[Pnr] GET Additional flight information',
  props<{ requestAdditionalFlightInfo: IRequestAdditionalFlightInfo }>()
);

export const GetAdditionalFlightInfoSuccess = createAction(
  '[Pnr] GET Additional flight information Success',
  props<{ additionalFlightInfo: IAdditionalFlightInfo }>()
);

export const SetVoluntaryOverrideSegments = createAction(
  '[Pnr] Set voluntaryOverrideSegments state',
  props<{ voluntaryOverrideSegments: number[] }>()
);

export const GetOAGFLTStatus = createAction('[Pnr] GET OAG FLT status');

export const GetOAGFLTStatusSuccess = createAction(
  '[Pnr] GET OAG FLT status success',
  props<{ OAGFLTStatus: string[] }>()
);

export const GetOAGFLTStatusFailed = createAction(
  '[Pnr] GET OAG FLT status failed',
  props<{ error: string }>()
);

export const RegisterUserLogInLog = createAction('[Pnr] Register user log in log');

export const RegisterUserLogInLogSuccess = createAction('[Pnr] Register user log in log success');

export const RegisterUserLogInLogFailed = createAction(
  '[Pnr] Register user log in log failed',
  props<{ error: string }>()
);
